import React, { useEffect, useRef, useState } from 'react';
import '../../../Static/Master/PackPrintStruct.css';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useMediaQuery, Button } from '@mui/material';
import ReactToPrint from 'react-to-print';
import { Grid, Paper } from '@mui/material';
import { fetchPackingData } from '../../../Store/PHPSlice/Packing/PackApis';
import { selectPackingData } from '../../Selectors/PackSelector/PackingSelector';
import FirmHeaderImg from '../../FieldsComponents/FirmHeaderImg';


const PackingPrint = () => {
    const { Id } = useParams();
    const dispatch = useDispatch();
    const componentRef = useRef();
    const [formData, setFormData] = useState({
        pkId: Id,
        dt: '',
        barcode: '',
        eType: '',
        pkMemo: '',
        baleNo: '',
        firm: '',
        firmAdrs: '',
        gst: '',
        party: '',
        adrs: '',
        trspt: '',
        shtoNm: '',
        shtoadrs: '',
        parcelqty: '',
        remark: '',
        item: '',
        schlNm: '',
        totQty: '',
        ordMan: '',
        totamt: '',
        userId: '1',
        firmId: ''
    })
    const [packInfo, setPackInfo] = useState([]);

    const packData = useSelector(selectPackingData);

    useEffect(() => {
        dispatch(fetchPackingData(Id))
    }, [Id, dispatch]);

    useEffect(() => {
        if (packData?.data) {
            const item = packData?.data;
            setFormData(prev => ({
                ...prev,
                adrs: item.adrs,
                dt: item.dt,
                eType: item.eType,
                firm: item.firmNm,
                parcelqty: item.parcel_qty,
                party: item.partyNm,
                pkMemo: item.pkMemo,
                remark: item.remark,
                schlNm: item.schoolNm,
                shtoNm: item.shipNm,
                shtoadrs: item.ship_adrs,
                totQty: item.totqty,
                totamt: item.totamt,
                trspt: item.transportNm,
                firmAdrs: item.firmAdrs,
                gst: item.gst,
                firmId: item?.firmId || ''
            }));
        }
        if (packData?.Info && packData.Info?.length > 0) {
            const info = packData.Info;
            setPackInfo(info);
        }
    }, [packData]);


    function numberToWords(num) {
        const below20 = [
            'Zero', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine',
            'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen',
            'Eighteen', 'Nineteen'
        ];
        const tens = [
            '', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'
        ];
        const thousands = ['', 'Thousand', 'Million', 'Billion', 'Trillion'];

        if (num === 0) return below20[0];

        let words = '';

        let i = 0;
        while (num > 0) {
            if (num % 1000 !== 0) {
                words = helper(num % 1000) + (thousands[i] ? ' ' + thousands[i] : '') + ' ' + words;
            }
            num = Math.floor(num / 1000);
            i++;
        }

        return words.trim().toUpperCase();

        function helper(n) {
            if (n === 0) return '';
            if (n < 20) return below20[n];
            if (n < 100) return tens[Math.floor(n / 10)] + (n % 10 !== 0 ? ' ' + below20[n % 10] : '');
            return below20[Math.floor(n / 100)] + ' Hundred' + (n % 100 !== 0 ? ' ' + helper(n % 100) : '');
        }
    }

    // Example usage:
    // console.log(numberToWords(123)); // Output: "One Hundred Twenty Three"
    // console.log(numberToWords(1234567)); // Output: "One Million Two Hundred Thirty Four Thousand Five Hundred Sixty Seven"


    return (

        <Grid item xs={12}>
            <Paper>
                <div ref={componentRef} style={{ padding: '1%' }}>
                    {/* Heading */}
                    {formData.firmId !== '' && <FirmHeaderImg firmId={formData.firmId} />}
                    <h3 className="heading">PACKING SLIP</h3>

                    {/* Upper part: Two tables side by side */}
                    <div className="flex-container">
                        {/* Left Table */}
                        <table>
                            <tbody>
                                <tr>
                                    <td><h2>{formData.firm}</h2> <br />
                                        {formData.firmAdrs}
                                        <br />
                                        <b>GST No.:</b> {formData.gst}
                                    </td>
                                </tr>
                                <tr>
                                    <td><h3>TO:</h3> <br />
                                        <b>{formData.party}</b> <br />
                                        {formData.adrs}
                                    </td>
                                </tr>

                            </tbody>
                        </table>

                        {/* Right Table */}
                        <table>

                            <tbody>

                                <tr>
                                    <td>Slip Memo:</td>
                                    <td>{formData.pkMemo}</td>
                                </tr>
                                <tr>
                                    <td>Date:</td>
                                    <td>{formData.dt}</td>
                                </tr>
                                <tr>
                                    <td>Transport:</td>
                                    <td>{formData.trspt}</td>
                                </tr>
                                <tr>
                                    <td>Remark:</td>
                                    <td>{formData.remark}</td>
                                </tr>
                                <tr>
                                    <td>No. of Cartoons:</td>
                                    <td>{formData.parcelqty}</td>
                                </tr>
                                <tr>
                                    <td>Ship To:</td>
                                    <td>{formData.shtoNm}</td>
                                </tr>
                                <tr>
                                    <td>Ship Address:</td>
                                    <td>{formData.shtoadrs}</td>
                                </tr>

                            </tbody>
                        </table>
                    </div>

                    {/* Main Table */}
                    {packInfo.length > 0 &&

                        <table className="main-table">
                            <thead>
                                <tr>
                                    <th>SR NO.</th>
                                    <th>PARTICULARS</th>
                                    <th>SIZE</th>
                                    <th>QTY</th>
                                    <th>RATE</th>
                                    <th>AMOUNT</th>
                                </tr>
                            </thead>
                            <tbody>
                                {packInfo.map((item, index) => (
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{item.itemNm}</td>
                                        <td>{item.size}</td>
                                        <td>{item.qty}</td>
                                        <td>{item.rate}</td>
                                        <td>{item.tot}</td>
                                    </tr>
                                ))}
                                <tr>
                                    <td></td>
                                    <td></td>
                                    <td><b>Total</b></td>
                                    <td><b>{formData.totQty}</b></td>
                                    <td></td>
                                    <td><b>{formData.totamt}</b></td>
                                </tr>
                            </tbody>
                        </table>
                    }

                    {/* Footer */}
                    <div className="flex-container">
                        <table>
                            <tbody>
                                <tr>
                                    <td>AMOUNT IN WORDS: <br />
                                        <b>{numberToWords(parseFloat(formData.totamt))}</b>
                                    </td>


                                </tr>
                                <tr>
                                    <td>TOTAL QTY: <b> {formData.totQty}</b></td>

                                </tr>
                            </tbody>
                        </table>

                        <table>

                            <tbody>

                                <tr>
                                    <td>TOTAL :</td>
                                    <td><b>{formData.totamt}</b></td>

                                </tr>

                            </tbody>
                        </table>
                    </div>
                </div>

                <div style={{ margin: '2% 5%' }}>
                    <ReactToPrint
                        trigger={() => <Button variant="contained" color="primary">Print</Button>}
                        content={() => componentRef.current}
                    />
                </div>
            </Paper>
        </Grid>
    );
};

export default PackingPrint;
